import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  text-align: center;

  display: flex;
  align-items: center;
  flex-direction: column;

  h1 {
    font-size: 40px;
    line-height: 40px;
  }

  ${({ theme }) => css`
    gap: ${theme.padding.biggest};
    padding: ${theme.padding.biggest} 80px;

    @media (max-width: 768px) {
      padding: ${theme.padding.biggest} 16px;
      h1 {
        font-size: 24px;
        line-height: 32px;
      }
    }
  `}
`;

export const LogoContainer = styled.img`
  width: 80px;
  aspect-ratio: 1 / 1;
`;
